import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  customerTypeItem: {
    backgroundColor: '#F7F7F7',
    textAlign: 'left',
    fontSize: 20,
    lineHeight: 1.5,
    padding: '16px 16px',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  
    marginBottom: '16px',
    [theme.breakpoints.up('md')]: {
      fontSize: 20,
      padding: '32px 24px',
    },
  },
  benefitCard: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 24,
    flexDirection: 'column',
    textAlign: 'left',
    padding: '24px',
    height: '100%',
    width: '31%',

    [theme.breakpoints.down('md')]: {
      gap: 16,
      padding: '20px',
    },

    '& h4': {
      fontSize: 20,
      fontWeight: 600,
      marginBottom: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: 18,
      },
    },
    '& p': {
      fontSize: 18,
      fontWeight: 400,
      marginBottom: 0,
      lineHeight: 1.4,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
    },
  },
  benefitsContainer: {
    display: 'flex',
    gap: 24,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
      gap: 24,
    },
  },
  partnerStep: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 70,
    paddingBottom: '36px',
    marginBottom: '36px',
    '&:last-child': {
      marginBottom: 0,
      paddingBottom: 0,
    },
  },
}));
